import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import Callback from '@/views/Callback'
import Store from './store';

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    meta: {requiresAuth: true},
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue')
      },
      {
        path: '/icons',
        name: 'icons',
        component: () => import(/* webpackChunkName: "demo" */ './views/Icons.vue')
      },
      {
        path: '/profile/:clientId/:estacionId',
        name: 'Detalles de Estación de Servicio',
        component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue')
      },
      {
        path: '/maps',
        name: 'maps',
        component: () => import(/* webpackChunkName: "demo" */ './views/Maps.vue')
      },
      {
        path: '/clientes',
        name: 'Clientes',
        component: () => import(/* webpackChunkName: "demo" */ './views/Clientes.vue')
      },
      {
        path: '/estaciones',
        name: 'Estaciones de servicio',
        component: () => import(/* webpackChunkName: "demo" */ './views/Estaciones.vue')
      },
      {
        path: '/create',
        name: 'Crear cliente o estación',
        component: () => import(/* webpackChunkName: "demo" */ './views/CreateProfile.vue')
      }
    ]
  },
  {
    path: "/callback",
    name: "Callback",
    component: Callback,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('./views/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('./views/Register.vue')
      }
    ]
  }
];
const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const cb = to.matched.some(record => record.path == '/callback');
  if(cb) {
    Store.dispatch('auth0HandleAuthentication');
    next(false);
  }

  let routerAuthCheck = false;  
  let accessToken = localStorage.getItem('access_token');
  let idToken = localStorage.getItem('id_token');
  let expiration = localStorage.getItem('expires_at');
  if(accessToken && idToken && expiration) {
    let expiresAt = JSON.parse(expiration);
    routerAuthCheck = new Date().getTime() < expiresAt;  
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (routerAuthCheck) {
      next();
      Store.commit('setUserAuthorization', true)
    } else {
      router.replace('/login');
    }
  } else {
    Store.commit('setUserAuthorization', false)
    next(); // make sure to always call next()!
  }
})

export default router;
